import { render, staticRenderFns } from "./TUILoader.vue?vue&type=template&id=b40b2838"
import script from "./TUILoader.vue?vue&type=script&lang=js"
export * from "./TUILoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports